export default "__VITE_ASSET__$5KATmQl__"